var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.props.title))]),_vm._t("action")],2),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }